import { StorageService } from '@/services/core/storage'
import { useCurrentUser } from '@/contexts/UserContext'
import { useNetwork } from '@/contexts/NetworkContext'
import { isSuperAdmin } from '@/data/superAdmins'

/**
 * Whether the signed-in user gets Adnuntius support tools: while masquerading,
 * on network 2 (Adnuntius's own system network), or as a listed super admin.
 */
export function useSupportAccess(): boolean {
  const currentUser = useCurrentUser()
  const { currentNetwork } = useNetwork()
  const sessionUser = StorageService.getCurrentUser()
  return (
    !!StorageService.getMasquerade() ||
    currentNetwork?.tagId === '2' ||
    isSuperAdmin(currentUser?.username || sessionUser?.username)
  )
}
